module.exports = __webpack_public_path__ + "static/media/Hollywood Starlet.3c05055c.jpg";